import { useState } from 'react';
import { useMeasure } from 'react-use';
import { invokeEvent } from 'shared-base';
import { useCustomEvent } from '../../hooks/useCustomEvent';
import { Needle, Progress, SeekBarTrack, Wrapper } from './SeekBar.style';

export type SeekBarProps = {
  duration: number; // Total duration of the video (or content)
  isRunning: boolean;
};

export function SeekBar(props: SeekBarProps) {
  const { duration = 15, isRunning } = props;
  const [time, setTime] = useState(0);
  const [ref, { width }] = useMeasure<HTMLDivElement>();

  useCustomEvent('MUSIC_TIME', (data: Json) => {
    const { ts } = data;
    setTime(ts);
  });

  function onSeek(time: number) {
    invokeEvent('MUSIC_SEEK', { ts: time });
  }

  function onClick(e: React.MouseEvent<HTMLDivElement>) {
    if (width === 0) return;

    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percentage = Math.max(0, Math.min(100, (x / width) * 100));

    const time = (percentage / 100) * duration;
    if (onSeek) {
      onSeek(time);
    }
  }

  function renderNeedle() {
    const style = {
      left: `${(time / duration) * 100}%`,
    };

    return <Needle style={style} />;
  }

  const progressWidth = (time / duration) * 100;

  return (
    <Wrapper className='SeekBar-wrapper' data-testid='SeekBar-wrapper'>
      <SeekBarTrack ref={ref} onClick={onClick}>
        <Progress style={{ width: `${progressWidth}%` }} />
        {renderNeedle()}
      </SeekBarTrack>
    </Wrapper>
  );
}

export default SeekBar;
